import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanDeactivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { JwtService } from '../services/jwt.service';
import { Sweetalert2Service } from '../services/sweet-alert.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild, CanDeactivate<unknown>, CanLoad {

// FALTA VALIDAR CONTRA API JWT, SI YA NO ESTA AUTORIZADO ELIMINAR TOKEN

  constructor(private router: Router, private jwt: JwtService, private sweetAlert: Sweetalert2Service) {

  }
  canActivate(): boolean {
    let session = sessionStorage.getItem('session_token');
    if (session !== undefined && session !== null) {
      this.jwt.setToken(session);
      if (this.jwt.isTokenExpired()) {
        this.router.navigate(['/']);
        this.sweetAlert.sweetWarning("Sesión Cerrada","Por tu segúridad debes iniciar nuevamente sesión");
        return false;
      } else {
        return true;
      }
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
}
